<template>
  <b-modal
    id="apply-domain-template-modal"
    :title="$t('label.domain_add')"
    scrollable
    hide-footer>
    <div>
      En cliquant sur <b>Ajouter</b>, vous ajoutez les domaines d'un template à l'établissement. Les domaines en double ne seront pas dupliqués.<br>
      En cliquant sur <b>Remplacer</b>, les domaines actuels de l'établissement seront désactivés et les domaines du template seront appliqués avec l'association des patgames à l'établissement. Il faudra ré-associer les activités externes aux domaines de l'établissement.
    </div>
    <b-table 
      :fields="fields"
      :items="templates">

      <template #cell(action)="row">
        <b-button size="sm" variant="secondary" @click="showDomains(row.item)">Voir</b-button>
        <b-button size="sm" variant="primary" :disabled="loading" @click="add(row.item.id, false)">Ajouter</b-button>
        <b-button size="sm" variant="warning" :disabled="loading" @click="add(row.item.id, true)">Remplacer</b-button>
      </template>

    </b-table>

    <modal-show-domains-template-info :establishment="establishment" ref="modalShowDomainsTemplateInfo" />
  </b-modal>
</template>

<script>
import ModalShowDomainsTemplateInfo from './ModalShowDomainsTemplateInfo.vue';

import { applyTemplate, getTemplatesDomain } from '../services/establishment';

export default {
  props: {
    establishment: {
      type: Object,
      required: true,
    }
  },
  components: {
    ModalShowDomainsTemplateInfo,
  },
  data() {
    return {
      templates: [],
      loading: false,
      error: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          label: {
            label: this.$t('label.template_name'),
            sortable: true,
          }
        },
        {
          action: {
            label: this.$t('label.action'),
            sortable: true,
          }
        },
      ] 
    },
  },
  methods: {
    async show() {
      this.error = null;
      this.loading = false;
      this.templates = await getTemplatesDomain();
      this.$bvModal.show("apply-domain-template-modal")
    },
    hide() {
      this.$bvModal.hide("apply-domain-template-modal")
    },
    showDomains(template) {
      this.$refs.modalShowDomainsTemplateInfo.show(template);
    },
    async add(id, replace=false) {
      const res = await applyTemplate(this.establishment.esta_id, id, replace)
      if (res !== undefined) {
        const update = res.filter(r => r.status === 'update').length
        const insert = res.filter(r => r.status === 'insert').length
        this.showToast('success', `Template appliquée avec succès (modifié(s): ${update}, ajouté(s): ${insert})`, this.$t('label.domain_template_add'))
        this.hide();
        this.$emit('onApplied')
      }
    },
  }
}
</script>